const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_authenticated-user/superuser/afpant/$orgNumber/intensjonssvar/$intentionMessageResponseId/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { routeLoaderApiClient } from "@/lib/api";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_authenticated-user/superuser/afpant/$orgNumber/intensjonssvar/$intentionMessageResponseId/")({
  loader: async ({
    params
  }) => {
    const {
      orgNumber,
      intentionMessageResponseId
    } = params;
    const res = await routeLoaderApiClient.superuser.afpant[":orgNumber"]["intention-message-response"][":intentionMessageResponseId"].$get({
      param: {
        orgNumber,
        intentionMessageResponseId
      }
    });
    if (res.ok === false) {
      throw new Error("Failed to fetch intention message response");
    }
    return {
      response: await res.json()
    };
  },
  head: () => ({
    meta: [{
      title: "Intensjonssvar | Alice & Bob"
    }]
  }),
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});